import React from 'react';
import { styled } from '@mui/material/styles';
import {
    Button,
    Grid
} from '@mui/material';
import logo from '../../images/EA_logo.svg';

const PREFIX = 'Navbar';

const classes = {
    root: `${PREFIX}-root`,
    logo: `${PREFIX}-logo`
};


const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.root}`]: {
        display: 'flex',
    },

    [`& .${classes.logo}`]: {
        height: "48px",
        margin: theme.spacing(1),
    }
}));

function Navbar() {


    let actionButton;

    function handleRevert(event) {
        event.preventDefault();
        window.location.href = window.location.origin;
    }

    actionButton = <Root>
        <Button style={{ backgroundColor: "white" }} sx={{textTransform: "none"}} variant="outlined" color="primary" onClick={handleRevert}>
            Sign In
        </Button>
    </Root>

    return (
        <Root className={classes.root}>
            <Grid container spacing={0}>
                <Grid item xs={4}>
                    <a href= "https://www.energyaustralia.com.au" target="_blank" rel="noreferrer">
                        <img
                            src={logo}
                            alt="logo"
                            className={classes.logo}
                        />
                    </a>
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                    <div>&nbsp;</div>
                    {actionButton}
                </Grid>
            </Grid>
        </Root>
    );
}

export default Navbar;